import { render, staticRenderFns } from "./StockClosingNew_Items.vue?vue&type=template&id=4778403e&"
import script from "./StockClosingNew_Items.vue?vue&type=script&lang=js&"
export * from "./StockClosingNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports